import { PAGINATION_LIMIT } from '@/constants/constant'

type ResponseSuccess = {
  message: string
}

type ErrorField = {
  domain: string
  message: string
}

type Pagination = {
  total?: number
  page?: number
  limit?: number
}

type SearchState = {
  phrase?: string | null
}

type Response<T> = {
  data: T
}

enum SortDirectionEnum {
  ASC = 'asc',
  DESC = 'desc',
}

type SortField = {
  field: string
  direction: SortDirectionEnum
}

type SortState = {
  sorts?: Array<SortField> | null
}

type WithFilter<T> = Pagination & {
  nodes: T
}

type RequestQuery<Filter extends Object = {}> = Pagination & SearchState & SortState & Filter

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialQueryState: RequestQuery<any> = {
  page: 1,
  limit: PAGINATION_LIMIT,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialFilterResponse: WithFilter<Array<any>> = {
  nodes: [],
  total: 0,
  ...initialQueryState,
}

export { 
  initialFilterResponse, 
  initialQueryState, 
  SortDirectionEnum,
}

export type {
  WithFilter,
  RequestQuery,
  SortState,
  SortField,
  Response,
  SearchState,
  Pagination,
  ErrorField,
  ResponseSuccess,
}
